import {Brick, registerBrick} from 'olympe';

/**
 * This brick converts a list of user emails to a payload that can be sent to the MS Graph API using batch endpoint
 */
export default class GraphAPICreateBatchPayloadForGettingUserIDFromEmails extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string[]} userEmails
     * @param {function(string)} setPayload
     */
    update($, [userEmails], [setPayload]) {
        const emails = userEmails.flatMap((email) => email.split(';'));
        // One request accept no more than 15 user ID, so we subdivide the user emails in group of 15
        // And we can send 20 requests max
        const MAX_FILTER_BY_REQUEST = 15;
        const MAX_REQUESTS_BY_BATCH = 20;
        const groupOfEmails = [];
        for (let i = 0; i < emails.length && i < MAX_FILTER_BY_REQUEST * MAX_REQUESTS_BY_BATCH; i += MAX_FILTER_BY_REQUEST) {
            groupOfEmails.push(emails.slice(i, i + MAX_FILTER_BY_REQUEST));
        }

        const requests = groupOfEmails.map((emails, idx) => ({
            url: `/users?$count=true&$filter=mail in ('${emails.join(`','`)}')&$select=id,mail,onPremisesSamAccountName,givenName,surname`,
            method: 'GET',
            id: idx,
            headers: {
                ConsistencyLevel: 'eventual',
            },
        }));

        const payload = {requests: requests};

        setPayload(JSON.stringify(payload));
    }
}

registerBrick('019324999c01d23d7d54', GraphAPICreateBatchPayloadForGettingUserIDFromEmails);
